import React, { useState, useEffect } from 'react';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import './Add_User.css';
import Footer from './Footer.js';
import { useNavigate, useParams } from 'react-router-dom';
import { BASE_URL } from './Constants'; // Import BASE_URL

const Edit_Area = () => {
  const [formData, setFormData] = useState({
    area: '',
  });
  const [formError, setFormError] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();

  // Fetch area details on mount
  useEffect(() => {
    const fetchArea = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${BASE_URL}get_area/${id}`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        // if (!response.ok) {
        //   throw new Error('Failed to fetch area');
        // }

        const data = await response.json();
        if (data.status && data.data) {
          setFormData({ area: data.data.area || '' });
        } else {
          setFormError('Area not found');
        }
      } catch (err) {
        setFormError(err.message);
      }
    };

    fetchArea();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.area.trim()) {
      setFormError('Area name is required.');
      return;
    }

    try {
      const token = localStorage.getItem('authToken');
      const body = new FormData();
      body.append('area', formData.area);

      const response = await fetch(`${BASE_URL}update_area/${id}`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body,
      });

      const result = await response.json();
      if (result.status) {
        navigate('/manage_areas');
      } else {
        throw new Error(result.message || 'Failed to update area');
      }
    } catch (err) {
      setFormError(err.message);
    }
  };
  const handleCancel = () => {
    navigate('/manage_areas');
  }
  return (
    <div className="page-wrapper">
      <HeaderMobile />
      <Sidebar />
      <div className="page-container">
        <Header />
        <div className="main-content">
          <div className="section__content section__content--p30">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-6 offset-lg-3">
                  <div className="card add-user-card">
                    <div className="card-header">
                      <h2>Edit Area</h2>
                    </div>
                    <div className="card-body">
                      <form onSubmit={handleSubmit}>
                        {formError && <div className="alert alert-danger">{formError}</div>}

                        <div className="form-group">
                          <label htmlFor="area">Area Name</label>
                          <input
                            type="text"
                            id="area"
                            name="area"
                            className="form-control"
                            value={formData.area}
                            onChange={handleInputChange}
                          />
                        </div>
                        <div style={{ display: 'flex', gap: '10px' }}>
                        <button type="submit" className="btn btn-primary">
                          Update
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                            Cancel
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Edit_Area;
